// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zip-code-wrap[data-v-3f55ba4d]{width:450px;display:inline-block}.zip-code-wrap[data-v-3f55ba4d]  .el-autocomplete,.zip-code-wrap[data-v-3f55ba4d]  .el-input{width:100%}.zip-code-popper .address-suggestion[data-v-3f55ba4d]{padding:5px 10px;font-size:13px;line-height:1.5;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
module.exports = exports;
